// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3ZzJ8","calendarButtons":"ClockData_calendarButtons__35Wde"};